import { colors } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";

export const CalenderFilterEnum = {
  All: 0,
  This_Week: 1,
  Last_Week: 2,
  This_Month: 3,
  Last_Month: 4,
  This_Quarter: 5,
  Last_Quarter: 6,
  This_6_Months: 7,
  Last_6_Months: 8,
  This_Year: 9,
  Last_Year: 10,
  Custom_Date_Range: 11,
  Todays: 12, // <-- Add this new value
};
// utils/reactSelectStyles.js
export const globalSelectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  menu: (base) => ({
    ...base,
    zIndex: 99999,
    maxHeight: "250px", // Set max height for the dropdown
    overflowY: "auto", // Enable scrolling if needed
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "200px", // Adjust list height
    overflowY: "auto",
    zIndex: 99999999,
  }),
  control: (base) => ({
    ...base,
    fontSize: "12px",
    minHeight: "38px",
  }),
  option: (base, state) => ({
    ...base,
    // height: "30px",
    fontSize: "12px",
    padding: "6px 10px",
    backgroundColor: state.isSelected ? "#E86B1B" : "white",
    color: state.isSelected ? "white" : "black",
    cursor: "pointer",
    ":hover": {
      backgroundColor: "#F4AD80",
      color: "black",
    },
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "12px",
    color: "black",
  }),
};

export const JobEnum = {
  Job: 1,
  Tender: 2
  // TaskSheet: 2,
  // JobTimeline: 3,
  // MissingLog: 4,
  // Queries: 5,
  // Draft: 6,
  // Documents: 7,
  // Reviewer: 8,
};

export const JobListEnum = {
  All: null,
  Completed: 1,
  PredefinedJob: 2,
  Assign: 3,
};
export const JobTaskListEnum = {
  All: null,
  Do: 1,
  Delegate: 2,
  Demand: 3,
  LatterOn: 4,
};
export const SettingEnum = {
  UsersRole: 1,
  Designation: 2,
  Services: 3,
  ClientIndustry: 4,
  Statuses: 5,
  Checklist: 6,
  ClientGrouping: 7,
  LeaveType: 8,
  KRA: 9,
  ProjectStage: 10,
  TimeSlotMaster: 11,
};
export const UserEnum = {
  ManageUser: 1,
  DeactivateUser: 2,
};
export const FrequencyEnum = {
  Monthly: 1,
  Yearly: 2,
  Onetime: 3,
  Custom: 4,
};

export const CampaignEnum = {
  UpcomingCampaigns: 1,
  CompletedCampaigns: 2,
};


export const ConfigureEnum = {
  DivisionalCategory: 1,
  DivisionalSubCategory: 2,
  Department: 3,
  Designation: 4,
  Zone: 5,
  Location: 6,
  JobCategory: 7,
  City: 8,
  RoleType: 9,
  ExpenseCategory: 10,
  TenderType: 11,
  CompanyPayment: 12,
  Bank: 13
};
export const ClientEnum = {
  Client: 1,
  Tender: 2,
  Vendor: 3,

};

export const StaffEnum = {
  Active: 1,
  Deactive: 2,
};

export const DailySlip = {
  DailyDuty: 1,
  weeklyProgress: 2,

};

export const Wallet = {
  Wallet: 1,
  Expense: 2,
  AdvancedSalary: 3,
  BusinessDevelopmentExpense: 4,
  CompanyPayment: 5
}


export const ProjectEnum = {
  project: 1
}

export const ReportEnum = {
  JobReport: 1,
  ProjectReport: 2,
  AttendanceReport: 3,
  ClientReport: 4,
  ExpenseReport: 5,
  ProfitLossReport: 6,
  TenderReport: 7,
  TourMapReport: 8,
  // PaymentSummaryReport: 1,
  TaskReport: 9,
  ProfitabilityReport: 10,
  TeamPerformanceReport: 11,
  ServiceReport: 12,
  Attendance: 13,
  TenderStatusReport: 14,
  Project: 15,
  EmployeePerformanceReport: 16
};

export const DashboardExpenseReportEnum = {
  TenderReport: 1,
  ExpenseReport: 2,

};
